import { Button, Input } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CREATE_jwel } from "../Config/Config";
import Header from "../Header";
import SidebarDrawer from "../SidebarDrawer";
import styles from "./BarCodeCheck.module.css";

const BarCodeCheck = () => {
  const [open, setOpen] = useState(false);
  const [barCode, setBarCode] = useState();
  const [barCodeData, setBarCodeData] = useState([]);
  // const [imagesData, setImagesData] = useState([]);
  // const [userArea, setUserArea] = useState();
  // const [userName, setUserName] = useState();
  // const [singleImage, setSingleImage] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);

  const imageUrls = localStorage.getItem("images").split(",");
  const imagesData = imageUrls;
  const userArea = localStorage.getItem("city");
  const userName = localStorage.getItem("user");
  const singleImage = localStorage.getItem("singleImage");
  const tenantName = localStorage.getItem("tenantName");

  const toggleDrawer = () => {
    setOpen(false);
  };

  const barCodeAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CURRENT_STOCK&where=DesignCode='${barCode}'`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setBarCodeData(data);
        setBarCode("");
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  // const userAPI = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=FIRM_CONFIGURE`,
  //       {
  //         headers: {
  //           tenantName: tenantName,
  //         },
  //       }
  //     );

  //     const data = response.data;

  //     if (Array.isArray(data) && data.length > 0) {
  //       const imageUrls = data[0]?.EPASS1.split(",");
  //       setImagesData(imageUrls);
  //       setUserName(data[0]?.FIRMNAME);
  //       setUserArea(data[0]?.CITY);
  //       setSingleImage(data[0]?.EPASS2);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching estimation count:", error);
  //   }
  // };

  const handleReset = () => {
    setBarCode("");
    setBarCodeData([]);
  };

  // useEffect(() => {
  //   userAPI();
  // }, []);

  useEffect(() => {
    if (imagesData.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % imagesData.length);
      }, 1500);
      return () => clearInterval(interval);
    }
  }, [imagesData]);

  const result = (barCodeData[0]?.PQTY ?? 0) - (barCodeData[0]?.Qty ?? 0);

  return (
    <div>
      <Header setOpen={setOpen} />
      <SidebarDrawer
        open={open}
        toggleDrawer={toggleDrawer}
        singleImage={singleImage}
        userArea={userArea}
        userName={userName}
      />
      <div className={styles.carouselContainer}>
        <div
          className={styles.carouselSlider}
          style={{
            transform: `translateX(-${currentIndex * 33.33}%)`,
            width: `${imagesData.length * 100}%`,
          }}
        >
          {imagesData.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`img-${index}`}
              className={styles.carouselImage}
            />
          ))}
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <h3 className={styles.heading}>Bar Code Check</h3>
        </div>
        <div className={styles.estimationTagContainer}>
          <div className={styles.tagNoSection}>
            <span className={styles.tagLabel}>Bar Code</span>
            <Input
              className={styles.tagInput}
              value={barCode}
              autoFocus={true}
              onChange={(e) => {
                // const value = e.target.value.replace(/\D/g, "");
                // if (value.length <= 8) {
                //   setBarCode(value);
                // }
                setBarCode(e.target.value);
              }}
            />
          </div>

          <div className={styles.buttonSection}>
            <Button
              type="primary"
              htmlType="submit"
              className={styles.submitButton}
              onClick={() => {
                barCodeAPI();
              }}
            >
              Show
            </Button>

            <Button
              type="primary"
              danger
              className={styles.resetButton}
              onClick={handleReset}
            >
              Reset
            </Button>
          </div>
        </div>
        {barCodeData.length > 0 && (
        <div className={styles.fullWidthStone4}>
              <p className={styles.mainHeading4}>{barCodeData[0]?.DesignCode}</p>
            </div>
            )}
        <div className={styles.cardContainer}>
          <div className={styles.infoBox}>
            <div className={styles.fullWidthStone}>
              <p className={styles.mainHeading}>Supplier Information</p>
            </div>
            <div className={styles.rowTagTwoCol}>
              <div className={styles.column}>
                <span className={styles.label}>Inv No</span>
                <span className={styles.separator}>:</span>
                <span className={styles.value}>
                  {barCodeData[0]?.InvNO || "-"}
                </span>
              </div>
              <div className={styles.column}>
                <span className={styles.label}>Inv Date</span>
                <span className={styles.separator}>:</span>
                <span className={styles.value}>
                  {barCodeData[0]?.Invdate
                    ? dayjs(barCodeData[0]?.Invdate).format("DD-MMM-YYYY")
                    : "-"}
                </span>
              </div>
            </div>

            <div className={styles.rowTagTwoCol}>
              <div className={styles.column}>
                <span className={styles.label}>Entry No</span>
                <span className={styles.separator}>:</span>
                <span className={styles.value}>
                  {barCodeData[0]?.ENTRYNO || "-"}
                </span>
              </div>
              <div className={styles.column}>
                <span className={styles.label}>Entry Date</span>
                <span className={styles.separator}>:</span>
                <span className={styles.value}>
                  {barCodeData[0]?.ENTRYDATE
                    ? dayjs(barCodeData[0]?.ENTRYDATE).format("DD-MMM-YYYY")
                    : "-"}
                </span>
              </div>
            </div>

            <div className={styles.rowTag}>
              <span className={styles.label}>Party Name</span>
              <span className={styles.separator}>:</span>
              <span className={styles.value}>
                {barCodeData[0]?.Partyname || "-"}
              </span>
            </div>

            <div className={styles.rowTag}>
              <span className={styles.label}>City</span>
              <span className={styles.separator}>:</span>
              <span className={styles.value}>
                {barCodeData[0]?.Area || "-"}
              </span>
            </div>
          </div>
        </div>
        <div className={styles.cardContainer1}>
          <div className={styles.infoBox1}>
            <div className={styles.fullWidthStone1}>
              <p className={styles.mainHeading1}>Product Information</p>
            </div>
            <div className={styles.rowTag1}>
              <span className={styles.label1}>Purchase Type</span>
              <span className={styles.separator1}>:</span>
              <span className={styles.value1}>
                {barCodeData[0]?.PTYPE || "-"}
              </span>
            </div>
            <div className={styles.rowTag1}>
              <span className={styles.label1}>Product Name</span>
              <span className={styles.separator1}>:</span>
              <span className={styles.value1}>
                {barCodeData[0]?.ProdName || "-"}
              </span>
            </div>
            <div className={styles.rowTag1}>
              <span className={styles.label1}>Brand Name</span>
              <span className={styles.separator1}>:</span>
              <span className={styles.value1}>
                {barCodeData[0]?.CompName || "-"}
              </span>
            </div>
            <div className={styles.rowTag1}>
              <span className={styles.label1}>Group Name</span>
              <span className={styles.separator1}>:</span>
              <span className={styles.value1}>
                {barCodeData[0]?.GroupName || "-"}
              </span>
            </div>
            <div className={styles.rowTagTwoCol1}>
              <div className={styles.column1}>
                <span className={styles.label1}>Size</span>
                <span className={styles.separator1}>:</span>
                <span className={styles.value1}>
                  {barCodeData[0]?.Prodsize || "-"}
                </span>
              </div>
              <div className={styles.column1}>
                <span className={styles.label1}>Fashion</span>
                <span className={styles.separator1}>:</span>
                <span className={styles.value1}>
                  {barCodeData[0]?.FITTING || "-"}
                </span>
              </div>
            </div>
            <div className={styles.rowTagTwoCol1}>
              <div className={styles.column1}>
                <span className={styles.label1}>Color</span>
                <span className={styles.separator1}>:</span>
                <span className={styles.value1}>
                  {barCodeData[0]?.COLOUR || "-"}
                </span>
              </div>
              <div className={styles.column1}>
                <span className={styles.label1}>Offer</span>
                <span className={styles.separator1}>:</span>
                <span className={styles.value1}>
                  {barCodeData[0]?.SLEVES || "-"}
                </span>
              </div>
            </div>
            <div className={styles.rowTagTwoCol1}>
              <div className={styles.column1}>
                <span className={styles.label1}>HSN Code</span>
                <span className={styles.separator1}>:</span>
                <span className={styles.value1}>
                  {barCodeData[0]?.HSNCODE || "-"}
                </span>
              </div>
              <div className={styles.column1}>
                <span className={styles.label1}>Code</span>
                <span className={styles.separator1}>:</span>
                <span className={styles.value1}>
                  {barCodeData[0]?.Code || "-"}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cardContainer3}>
          <div className={styles.infoBox3}>
            <div className={styles.fullWidthStone}>
              <p className={styles.mainHeading3}>Stock</p>
            </div>
            <div className={styles.rowTag3}>
              <span className={styles.label3}>Purchase Qty</span>
              <span className={styles.separator3}>:</span>
              <span className={styles.value3}>
                {barCodeData[0]?.PQTY || "-"}
              </span>
            </div>
            <div className={styles.rowTag3}>
              <span className={styles.label3}>Sale Qty</span>
              <span className={styles.separator3}>:</span>
              <span className={styles.value3}>{result || "-"}</span>
            </div>
            <div className={styles.rowTag3}>
              <span className={styles.label3}>Present Qty</span>
              <span className={styles.separator3}>:</span>
              <span className={styles.value3}>
                {barCodeData[0]?.Qty || "-"}
              </span>
            </div>
          </div>
        </div>
        <div className={styles.cardContainer2}>
          <div className={styles.infoBox2}>
            <div className={styles.fullWidthStone1}>
              <p className={styles.mainHeading2}>Purchase Cost Details</p>
            </div>
            <div className={styles.rowTag2}>
              <span className={styles.label2}>Gross DP</span>
              <span className={styles.separator2}>:</span>
              <span className={styles.value2}>
                {barCodeData[0]?.GrosDPrice
                  ? Number(barCodeData[0]?.GrosDPrice)?.toFixed(2)
                  : 0.0}
              </span>
            </div>
            <div className={styles.rowTag2}>
              <span className={styles.label2}>GST(%)</span>
              <span className={styles.separator2}>:</span>
              <span className={styles.value2}>
                {barCodeData[0]?.GSTNumber
                  ? barCodeData[0]?.GST
                  : 0}%
              </span>
            </div>
            <div className={styles.rowTag2}>
              <span className={styles.label2}>Net DP</span>
              <span className={styles.separator2}>:</span>
              <span className={styles.value2}>
                {barCodeData[0]?.DPrice
                  ? Number(barCodeData[0]?.DPrice)?.toFixed(2)
                  : 0.0}
              </span>
            </div>
            <div className={styles.rowTag2}>
              <span className={styles.label2}>Whole Sale Price</span>
              <span className={styles.separator2}>:</span>
              <span className={styles.value2}>
                {barCodeData[0]?.WPRICE
                  ? Number(barCodeData[0]?.WPRICE)?.toFixed(2)
                  : 0.0}
              </span>
            </div>
            <hr className={styles.fullWidthLine2} />
            <div className={styles.fullWidthStone1}>
              <p className={styles.mainHeading2}>Sale Cost Details</p>
            </div>
            <div className={styles.rowTag2}>
              <span className={styles.label2}>MRP</span>
              <span className={styles.separator2}>:</span>
              <span className={styles.value2}>
                {barCodeData[0]?.CPrice
                  ? Number(barCodeData[0]?.CPrice)?.toFixed(2)
                  : 0.0}
              </span>
            </div>
            <div className={styles.rowTag2}>
              <span className={styles.label2}>Dis(%)</span>
              <span className={styles.separator2}>:</span>
              <span className={styles.value2}>
                {barCodeData[0]?.Disamt
                  ? Number(barCodeData[0]?.Disamt )
                  : 0}%
              </span>
            </div>
            <div className={styles.rowTag2}>
              <span className={styles.label2}>OFFER Price</span>
              <span className={styles.separator2}>:</span>
              <span className={styles.value2}>
                {barCodeData[0]?.OFFER_DIS || "-"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BarCodeCheck;
